import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { environment } from '../environments/environment';
import { JwtHelper } from 'angular2-jwt';
import { User } from './classes/user';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { CookieService } from 'ngx-cookie-service';
import { Role } from './classes/enmus';

@Injectable()
export class AuthorizationService {

  private _AuthenticateController = 'Authenticate';
  private _AuthenticateAction = 'Browser';

  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  constructor(private router: Router, private cookieService: CookieService) {
    try {
      const jwthelper = new JwtHelper();
      this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem(environment.AUTHTOKEN)));
      this.currentUser = this.currentUserSubject.asObservable();
      if (this.currentUserValue !== null) {
        if (jwthelper.isTokenExpired(this.currentUserValue.Token)) {
          this.InitiateNullUser();
        }
      } else {
        if (this.cookieService.check('jwt_scelections')) {
          const jwt_token = this.cookieService.get('jwt_scelections');
          if (!jwthelper.isTokenExpired(jwt_token)) {
            const tokenJson = jwthelper.decodeToken(jwt_token);
            const _user = new User();
            _user.UserName = tokenJson.nameid;
            _user.Name = tokenJson.given_name;
            _user.Token = jwt_token;
            _user.Department = tokenJson.Department;
            _user.Faculty = tokenJson.Faculty;
            _user.Roles = new Array<string>();
            for (let i = 0; i < tokenJson.role.length; i++) {
              const tokenRole: string = tokenJson.role[i].toString();
              const role: Role = Role[tokenRole];
              _user.Roles.push(role);
            }
            this.currentUserSubject.next(_user);
            localStorage.clear();
            localStorage.setItem(environment.AUTHTOKEN, JSON.stringify(_user));
            this.cookieService.delete('jwt_scelections');
            let redirect = null;
            if (tokenJson.Redirect instanceof Array) {
              for (let i = 0; i < tokenJson.Redirect.length; i++) {
                if (tokenJson.Redirect[i] !== null && tokenJson.Redirect[i] !== '') {
                  redirect = tokenJson.Redirect[i];
                  break;
                }
              }
            }
            if (redirect !== null) {
              if (redirect === 'Nomination') { this.router.navigate(['/pages/nomination']) }
              if (redirect === 'Voting') { this.router.navigate(['/pages/voting']) }
            }
          } else {
            this.InitiateNullUser();
          }
        } else {
          this.InitiateNullUser();
        }
      }
    } catch (e) {
      this.InitiateNullUser();
      throw(e);
    }
  }
  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }
  private InitiateNullUser() {
    localStorage.clear();
    this.currentUserSubject.next(null);
  }

  public SignIn() {
    window.location.href = environment.WEBAPI_URL + '/Authenticate/Browser/';
  }

  public SignOut(localOnly: boolean) {
    this.InitiateNullUser();
    window.location.href = environment.WEBAPI_URL + '/Authenticate/SignOut/';
  }

  private GetUrl(): string {
    return environment.WEBAPI_URL;
  }

  private checkLocalStorage() {
    const lsci = 'localstoragecheckitem';
    try {
      window.localStorage.setItem(lsci, lsci);
      window.localStorage.removeItem(lsci);
      return true;
    } catch (e) {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/auth.service.ts